<footer class="site-footer">
  <div class="footer-shell">
    <div class="footer-brand">
      <a class="brand-link" routerLink="/">
        <img
          src="/assets/7a15b717b92f2a0adb485677e847fece4de33cba.webp"
          alt="Heyea Logo"
          width="200"
          height="200"
          decoding="async"
        />
        <span>Heyea Home</span>
      </a>
      <p>AI-Powered True Availability™ technology for smarter scheduling.</p>
    </div>

    <nav aria-label="Footer product links">
      <p class="footer-heading">Product</p>
      @for (item of productLinks; track item.path) {
      <a [routerLink]="item.path">{{ item.label }}</a>
      }
    </nav>

    <nav aria-label="Footer solution links">
      <p class="footer-heading">Solutions</p>
      @for (item of solutionLinks; track item.path) {
      <a [routerLink]="item.path">{{ item.label }}</a>
      }
    </nav>

    <nav aria-label="Footer company links">
      <p class="footer-heading">Company</p>
      @for (item of companyLinks; track item.path) {
      <a [routerLink]="item.path">{{ item.label }}</a>
      }
      <a routerLink="/contact">Contact Team</a>
    </nav>

    <nav aria-label="Footer legal links">
      <p class="footer-heading">Legal</p>
      @for (item of legalLinks; track item.path) {
      <a [routerLink]="item.path">{{ item.label }}</a>
      }
    </nav>
  </div>

  <div class="social-row">
    @for (social of socialLinks; track social.href) {
    <a [href]="social.href" target="_blank" rel="noopener noreferrer" [attr.aria-label]="social.label">
      <img [src]="social.icon" [alt]="social.label" width="24" height="24" loading="lazy" decoding="async" />
    </a>
    }
  </div>

  <p class="copyright">© {{ year }} Heyea. All rights reserved.</p>
</footer>
